import React from 'react';
import './VisitOurBeehive.css';
import { FaPhone, FaMapMarkerAlt, FaClock, FaDirections } from 'react-icons/fa';

// Import honeycomb images (replace with your actual images)
import honeycomb from './assets/honeycomb-2.png';

const VisitOurBeehive = () => {
    return (
        <div className="beehive-container">
            <div className="beehive-wrapper">
                {/* Left Side - Honeycomb Images */}
                <div className="beehive-left">
                    <div className="hexagon-shape">
                        <img src={honeycomb} alt="Privacy Shield Protection" className="hexagon-image" />
                    </div>
                </div>

                {/* Right Side - Content */}
                <div className="beehive-right">
                    <h2 className="beehive-title">Your Privacy Shield</h2>

                    <p className="beehive-description">
                        We prioritize your online privacy and data protection. Our website operates with <strong>zero tracking cookies, no analytics, and no personal data collection</strong>. You can browse freely and securely without compromising your personal information.
                    </p>

                    {/* Privacy Commitment */}
                    <div className="info-item">
                        <div className="info-icon">
                            <FaMapMarkerAlt />
                        </div>
                        <div className="info-content">
                            <div className="info-text">
                                Bagh-E-Rizwan Apartment, Gulshan-E-Iqbal, Karachi - Pakistan.
                            </div>
                            <a href="#" className="directions-link">
                                Read Privacy Policy <FaDirections className="arrow-icon" />
                            </a>
                        </div>
                    </div>

                    {/* Data Protection */}
                    <div className="info-item">
                        <div className="info-icon">
                            <FaClock />
                        </div>
                        <div className="info-text">
                            <div>24/7 Data Protection Monitoring</div>
                            <div>100% Cookie-Free Browsing Experience</div>
                        </div>
                    </div>

                    {/* Privacy Contact */}
                    <div className="info-item">
                        <div className="info-icon">
                            <FaPhone />
                        </div>
                        <div className="info-text">
                            +92 300 257 3177
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VisitOurBeehive;